export const BLACK_LISTED_ITEMS = [
  'provincie',
  'solvabiliteit',
  'solvabiliteitscore',
  'schuldquote',
  'schuldquotescore',
  'grondexploitatie',
  'grondexploitatiescore',
  'exploitatieruimte',
  'exploitatieruimtescore',
  'belastingcapaciteit',
  'belastingcapaciteitscore',
  // 'rapportcijfer',
  'inwoners',
  'colors',
  'ranking 2018',
  'ranking 2019',
  'id',
];

export const SELECTABLE_ITEMS = [
  // 'solvabiliteit',
  // 'schuldquote',
  // 'grondexploitatie',
  // 'exploitatieruimte',
  // 'belastingcapaciteit',
  // 'rapportcijfer',
];

export const TITLES_MAP = {
  ranking: 'positie',
  positie: 't.o.v. ####',
};
